// @flow

import * as React from "react";
import { useDispatch, useSelector } from "react-redux";

import { handleOktaRedirect } from "../actions/user";
import useAsyncState from "../hooks/useAsyncState";
import useInvertedNav from "../hooks/useInvertedNav";
import { PrimaryNavPad } from "../components/organisms/PrimaryNav";
import ServerErrorMessage from "../components/atoms/ServerErrorMessage";
import Button from "../components/atoms/Button";

import { ReactComponent as DotsLoader } from "../../assets/images/dots-loader.svg";
import Config from "../constants/Config";
import CustomMeta from "../components/atoms/CustomMeta";

const OktaRedirect = (): React.Node => {
    const { loggedIn } = useSelector((state: any): any => state.user);
    const dispatch = useDispatch();
    const [state, localActions] = useAsyncState();

    // invert primary nav color
    useInvertedNav();

    // check for okta login redirect on init
    React.useEffect(() => {
        localActions.request();

        dispatch(handleOktaRedirect())
            .then(() => {})
            .catch(error => {
                localActions.fail(
                    error.message ||
                        "There was an issue logging in with Okta single sign on.",
                    error.code
                );
            });
    }, []); // eslint-disable-line

    return (
        <React.Fragment>
            <CustomMeta title="Login" />
            <PrimaryNavPad />

            <div className="login-profile-body container-fluid center-xs">
                <br />
                <br />
                <br />
                <br />
                <br />
                {state.error ? (
                    <>
                        <ServerErrorMessage center={true}>
                            <h2 className="heading-2">
                                {state.errorCode === "email_already_existed"
                                    ? "Sorry, we can’t switch to that UTS email"
                                    : "Okta SSO sign in error"}
                            </h2>

                            <p>{state.error}</p>

                            {loggedIn ? (
                                <>
                                    <br />
                                    <Button
                                        inline={true}
                                        to={Config.routes.editProfile}
                                    >
                                        Ok
                                    </Button>
                                </>
                            ) : null}
                        </ServerErrorMessage>
                    </>
                ) : (
                    <>
                        <DotsLoader fill={"#008731"} />
                        <h2 className="heading-3">Logging in...</h2>
                    </>
                )}
            </div>
        </React.Fragment>
    );
};

export default OktaRedirect;
